"use client";
import { useRef, useEffect } from 'react';
import '../utils/assertion.js';
import { getParentIFrame } from '../utils/iframeUtils/getParentIFrame.js';
import { resizeModal, restoreModalSize } from '../utils/iframeUtils/iframeModalResize.js';
import { isIframeWithIframeResizer } from '../utils/iframeUtils/isIframe.js';
import { usePrevious } from './usePrevious.js';

/**
 * Используется для управления размером модального окна в iframe, при его открытии или закрытии.
 * Фиксит проблему, когда при открытии модального окна iframe-resizer не реагирует на это и не изменяет размеры iframe.
 *
 * @param {IResizeIframeModal} params - Параметры для настройки ресайза iframe модального окна.
 * @param {boolean | undefined} params.shouldResize - Параметр управляет необходимостью ресайза iframe.
 * @param {boolean | undefined} params.visible - Параметр видимости модального окна.
 * @returns {void}
 */
// скроллим к верху фрейма тк, ресайз будет четко по размеру окна устройства
const OFFSET_Y = 0;
const useResizeIframeModal = ({ shouldResize, visible }) => {
    const prevVisible = usePrevious(visible);
    const isResized = useRef(false);
    useEffect(() => {
        if (isIframeWithIframeResizer() && shouldResize && visible !== prevVisible) {
            if (visible) {
                isResized.current = true;
                resizeModal();
                // скролл к верху окна
                getParentIFrame()?.scrollToOffset(0, OFFSET_Y);
            }
            else if (isResized.current) {
                isResized.current = false;
                restoreModalSize();
            }
        }
    }, [visible, shouldResize, prevVisible]);
    useEffect(() => () => {
        if (isIframeWithIframeResizer() && isResized.current) {
            restoreModalSize();
        }
    }, []);
};

export { useResizeIframeModal };
//# sourceMappingURL=useResizeIframeModal.js.map
